import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const getMediaSrc = (img) => img?.lg_url || img?.md_url || img?.sm_url || img?.url || "";

const ProductMediaContext = createContext(null);

export const ProductMediaProvider = ({ children, images = [] }) => {
    const [openFullscreenSlider, setOpenFullscreenSlider] = useState(false);
    const [fullscreenCurrentIndex, setFullscreenCurrentIndex] = useState(0);

    useEffect(() => {
        if (!images.length) {
            setFullscreenCurrentIndex(0);
            setOpenFullscreenSlider(false);
            return;
        }

        if (fullscreenCurrentIndex >= images.length) {
            setFullscreenCurrentIndex(images.length - 1);
        }
    }, [images, fullscreenCurrentIndex]);

    const totalMedia = images.length;
    const fullscreenMedia = images[fullscreenCurrentIndex] || null;

    const openFullscreen = (index = 0) => {
        if (!images.length) {
            return;
        }
        setFullscreenCurrentIndex(Math.max(0, Math.min(index, images.length - 1)));
        setOpenFullscreenSlider(true);
    };

    const closeFullscreen = () => {
        setOpenFullscreenSlider(false);
    };

    const showPreviousFullscreenMedia = () => {
        if (!totalMedia) {
            return;
        }
        setFullscreenCurrentIndex((prev) => (prev - 1 + totalMedia) % totalMedia);
    };

    const showNextFullscreenMedia = () => {
        if (!totalMedia) {
            return;
        }
        setFullscreenCurrentIndex((prev) => (prev + 1) % totalMedia);
    };

    const value = useMemo(() => ({
        images,
        totalMedia,
        openFullscreenSlider,
        fullscreenCurrentIndex,
        fullscreenMedia,
        openFullscreen,
        closeFullscreen,
        showPreviousFullscreenMedia,
        showNextFullscreenMedia,
        setFullscreenCurrentIndex,
    }), [images, totalMedia, openFullscreenSlider, fullscreenCurrentIndex, fullscreenMedia]);

    return (
        <ProductMediaContext.Provider value={value}>
            {children}
        </ProductMediaContext.Provider>
    );
};

export const useProductMedia = () => {
    const context = useContext(ProductMediaContext);
    if (!context) {
        throw new Error("useProductMedia must be used within ProductMediaProvider");
    }
    return context;
};